import React, { useState } from 'react'
import { styles } from './index.sass'
import { Button, Form, Input, message, Spin, Card } from 'antd'
import { LinkOutlined } from '@ant-design/icons'
import { formDataRequest } from '../../api/axios_ml'

export const ArticleUpload = () => {
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm()

  const handleSubmit = async (values) => {
    setLoading(true)
    try {
      if (!values.url) {
        message.error('Please provide a URL')
        setLoading(false)
        return
      }

      console.log('URL to upload:', values.url)

      // Call ML upload API with the URL
      const mlResponse = await formDataRequest({
        path: '/api/ml/upload',
        method: 'post',
        data: {
          url: values.url
        }
      })

      message.success('Content uploaded to Knowledge Hub successfully!')
      form.resetFields()
      console.log('ML Response:', mlResponse)
    } catch (err) {
      console.error('Error uploading content:', err)
      message.error(
        (err.detail) || (err.message || 'Failed to upload content. Please try again.')
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={styles}>
      <div className="container">
        <h2>Upload Articles to Knowledge Hub</h2>
        
        <Card className="upload-card">
          <div className="form-container">
            <Form
              form={form}
              layout="vertical"
              onFinish={handleSubmit}
              className="upload-form"
            >
              <div className="form-field">
                <Form.Item
                  name="url"
                  label="ARTICLE URL"
                  rules={[
                    { required: true, message: 'Please input a URL' },
                    { type: 'url', message: 'Please enter a valid URL' }
                  ]}
                >
                  <Input
                    prefix={<LinkOutlined />}
                    placeholder="Please enter a valid UR"
                    disabled={loading}
                  />
                </Form.Item>
              </div>

              <div className="button-container">
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  size="large"
                  style={{ paddingTop: '10px'}}
                >
                  Upload to Knowledge Hub
                </Button>
              </div>
            </Form>
          </div>
        </Card>

        {loading && (
          <div className="processing-overlay">
            <div className="processing-content">
              <Spin size="large" style={{ marginBottom: '16px' }} />
              <div className="processing-text">Uploading...</div>
              <div className="processing-subtext">
                This may take a few minutes. Please wait.
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
